import axios from 'axios'
import {FACEBOOK_APP_ID, FACEBOOK_APP_SECRET} from '../config'

class FacebookService {
  static requestUrl = 'https://graph.facebook.com/v4.0'

  _userAccessToken = ''

  set accessToken(token) {
    this._userAccessToken = token
  }

  buildFacebookUrl(path) {
    return `${FacebookService.requestUrl}${path}`
  }

  deepleConnectLogin(projectId, onGetAccessToken) {
    if (projectId) {
      window.FB.getLoginStatus(resp => {
        if (resp.status === 'connected') {
          onGetAccessToken(resp)
        } else {
          window.FB.login(
            response => {
              onGetAccessToken(response)
            },
            {
              scope: 'pages_messaging,manage_pages',
            },
          )
        }
      })
    }
  }

  async getPageList() {
    const { data } = await axios.get(
      this.buildFacebookUrl(
        `/me/accounts?access_token=${this._userAccessToken}`,
      ),
    )
    return data
  }

  async getLongLiveToken() {
    const { data } = await axios.get(
      `https://graph.facebook.com/oauth/access_token?client_id=${FACEBOOK_APP_ID}&client_secret=${FACEBOOK_APP_SECRET}&grant_type=fb_exchange_token&fb_exchange_token=${
        this._userAccessToken
      }`,
    )
    return data.access_token
  }
}

const instance = new FacebookService()

export default instance



// WEBPACK FOOTER //
// ./src/facebook/facebookService.js